import { parseApiError } from "@/lib/parseApiError";
import type { AuthPortal } from "@/lib/portalTokens";

const BACKEND = process.env.NEXT_PUBLIC_BACKEND_URL;

export type LoginApiUser = {
  id?: string;
  mobile?: string;
  roles?: string[];
  has_org_role?: boolean;
};

export type LoginApiResponse = {
  access_token: string;
  token_type?: string;
  portal?: string;
  user?: LoginApiUser;
};

export async function loginWithPassword(
  mobile: string,
  password: string,
  portal: AuthPortal,
): Promise<LoginApiResponse> {
  const response = await fetch(`${BACKEND}/users/login-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ mobile, password, portal }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    const { message } = parseApiError(errorData, "登录失败");
    throw new Error(message);
  }

  return response.json();
}

export async function resetPasswordAndLogin(
  mobile: string,
  verificationCode: string,
  newPassword: string,
  passwordConfirm: string,
  portal: AuthPortal,
): Promise<LoginApiResponse> {
  const response = await fetch(`${BACKEND}/users/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      mobile,
      verification_code: verificationCode,
      new_password: newPassword,
      password_confirm: passwordConfirm,
      portal,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    const { message } = parseApiError(errorData, "重置密码失败");
    throw new Error(message);
  }

  return response.json();
}
